export default __webpack_public_path__ + "static/media/cal-ring.f55642ea.jpg";